import { borderRadius, colors, fontSize } from '../../../constants/styleConstants';
import { styles } from '../../../components/Fields/FormikAutocompleteSelect';

export const dateFilterStyle = {
  field: {
    height: '100%',
    maxHeight: '64px',
    width: '100%',
    position: 'relative',

    '& :hover': {
      '& input': {
        border: `1px solid ${colors.darkBlue}`,
      },
    },

    '& .DayPickerInput': {
      width: '100%',
      height: '100%',
      lineHeight: 2.2,
      '& input': {
        width: '100%',
        height: '100%',
        padding: '8px 10px 8px 40px',
        border: `1px solid ${colors.fieldsBorderGray}`,
        borderRadius: borderRadius.input,
        backgroundColor: colors.white,
      },
    },

    '& .DayPickerInput-Overlay': {
      zIndex: 10,
      minWidth: 200,
      width: '100%',
      margin: 'auto',

      '& :hover': {
        border: 'none',
      },

      '@media (max-width: 600px)': {
        fontSize: 12,
      },
    },
  },
  label: {
    position: 'absolute',
    left: 0,
    top: 0,
    color: colors.title,
    letterSpacing: 0.6,
    transformOrigin: 'left',
  },
  calendarIcon: {
    fill: colors.darkBlue,
    position: 'absolute',
    left: 6,
    top: 'calc(50% - 11px)',
  },
  clearIcon: {
    position: 'absolute',
    right: 10,
    top: 'calc(50% - 11px)',
    fill: colors.grey4,
    fontSize: '1.25rem',
    width: '1em',
    height: '1em',
    transition: 'fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    flexShrink: 0,
  },
  overlay: {
    fontSize: fontSize.smallTitle,
    margin: 'auto',

    '& .DayPicker-Caption': {
      textAlign: 'center',

      '& > select': {
        border: 'none',
      },
    },

    '& .DayPicker-NavButton--prev': {
      left: 10,
      backgroundImage: "url('/images/chevron-left.svg')",
      display: 'inline-block',
      fontSize: '1.5rem',
      transition: 'fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
      flexShrink: 0,
      userSelect: 'none',
      backgroundSize: '1.8em 1.8em',
      top: '0.3em',
      backgroundPosition: 'inherit',
    },

    '& .DayPicker-NavButton--next': {
      right: 10,
      backgroundImage: "url('/images/chevron-right.svg')",
      display: 'inline-block',
      fontSize: '1.5rem',
      transition: 'fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
      flexShrink: 0,
      userSelect: 'none',
      backgroundSize: '1.8em 1.8em',
      top: '0.3em',
      backgroundPosition: 'inherit',
    },

    '& .DayPicker-Day': {
      padding: '0 !important',
      width: 30,
      height: 30,
      lineHeight: 1,

      '&--today': {
        color: `${colors.blue} !important`,
      },

      '&--selected': {
        backgroundColor: `${colors.darkBlue} !important`,
        color: `${colors.white} !important`,
      },
    },
  },
  error: {
    '& .DayPickerInput': {
      '& input': {
        borderColor: colors.red,
      },
    },
  },
  errorColor: {
    color: colors.red,
  },
  required: {
    color: colors.blue,
    lineHeight: 1,
  },
  shrinkFieldClass: styles.shrink,
};
